/* src/app/ai-sourcing/ai-sourcing-insights-ai/ai-sourcing-insights-ai.component.scss */
.gradientbtn {
  padding: 7px 12px 7px 12px;
  border-radius: 4px;
  background-image:
    linear-gradient(
      49deg,
      #c845ab 13%,
      #e24e7f 60%);
  color: #ffffff;
}
.textBox {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.textBox2 {
  max-height: 70px;
  overflow: hidden;
}
.viewMore {
  overflow: visible;
  -webkit-line-clamp: unset;
}
.viewMore2 {
  overflow: visible;
  height: auto;
  max-height: unset;
}
.textBox p {
  line-height: 1.5;
}
.reg-btn {
  padding: 7px 40px;
  border-radius: 2px;
  border: solid 1px #2e93a1;
  background-color: #fff;
  color: #2e93a1;
}
.disabl-button {
  pointer-events: none;
  background-color: #cccccc;
  background-image: none;
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      258deg,
      #c845ab 84%,
      #e24e7f 49%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
/*# sourceMappingURL=ai-sourcing-insights-ai.component-WFRRFBQK.css.map */
